import React from "react";
import MainParticipantInfo from "../MainParticipantInfo/MainParticipantInfo";
import ParticipantTracks from "../ParticipantTracks/ParticipantTracks";
import useMainParticipant from "../../hooks/useMainParticipant/useMainParticipant";
import useSelectedParticipant from "../../hooks/useSelectedParticipant/useSelectedParticipant";

const MainParticipant: React.FC<any> = ({ room }) => {
  const mainParticipant = useMainParticipant(room);
  //   const { room } = window;
  const localParticipant = room?.localParticipant;
  const [selectedParticipant] = useSelectedParticipant();
  console.log("participants", room);

  const videoPriority =
    mainParticipant === selectedParticipant &&
    mainParticipant !== localParticipant
      ? "high"
      : null;

  return (
    <MainParticipantInfo participant={mainParticipant} room={room}>
      <ParticipantTracks
        participant={mainParticipant}
        videoOnly
        enableScreenShare={mainParticipant !== localParticipant}
        videoPriority={videoPriority}
        isLocalParticipant={mainParticipant === localParticipant}
      />
    </MainParticipantInfo>
  );
};

export default MainParticipant;
